import type { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField } from '@mui/material';

export interface ShapingFilterProps {
  variableName: string;
  searchString: string;
  setSearchString: Dispatch<SetStateAction<string>>;
}

export const VARIABLE_ACCORDION_SHAPING_FILTER_TEST_ID =
  'variable-accordion-shaping-filter-test-id';

const ShapingFilter: FC<ShapingFilterProps> = ({
  variableName,
  searchString,
  setSearchString,
}) => {
  const { t } = useTranslation('report');
  return (
    <Box
      sx={{
        pb: 1,
      }}
    >
      <TextField
        aria-label="Shaping search"
        fullWidth
        placeholder={`${t('searchPlaceholderSimple')} ${variableName} ${t(
          'searchPlaceholderValue',
        )}`}
        value={searchString}
        onChange={(event) => setSearchString(event.target.value)}
        data-test-id={VARIABLE_ACCORDION_SHAPING_FILTER_TEST_ID}
      />
    </Box>
  );
};

export default ShapingFilter;
